import React from 'react';

const TermsOfServiceGooglePlay = () => {
  const isMobile = window.innerWidth <= 768;
  const isSmallMobile = window.innerWidth <= 480;
  
  return (
    <div style={{
      maxWidth: '100%',
      margin: '0 auto',
      padding: isSmallMobile ? '15px 8px' : isMobile ? '20px 12px' : '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      lineHeight: '1.6',
      color: '#333',
      fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '16px'
    }}>
      <h1 style={{
        fontSize: isSmallMobile ? '20px' : isMobile ? '24px' : '32px',
        fontWeight: 'bold',
        color: '#424242',
        marginBottom: isSmallMobile ? '15px' : isMobile ? '20px' : '30px',
        textAlign: 'center',
        lineHeight: isSmallMobile ? '1.3' : '1.4'
      }}>
        📑 Regulamin aplikacji mobilnej (Google Play)
      </h1>

      <div style={{
        background: '#ffffff',
        borderRadius: isSmallMobile ? '6px' : isMobile ? '8px' : '12px',
        padding: isSmallMobile ? '15px 10px' : isMobile ? '20px 15px' : '40px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        marginBottom: isSmallMobile ? '15px' : isMobile ? '20px' : '30px'
      }}>
        <h2 style={{ 
          fontSize: isSmallMobile ? '18px' : isMobile ? '20px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '15px' : '20px', 
          color: '#424242',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          Regulamin korzystania z aplikacji "Generator Liczb Lotto AI"
        </h2>

        <h3 style={{ 
          fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '20px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '18px' : isMobile ? '20px' : '25px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          1. Informacje ogólne
        </h3>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>1.1.</strong> Właścicielem i administratorem aplikacji jest Michal Jedynasty.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>1.2.</strong> Regulamin określa zasady korzystania z aplikacji dostępnej w Google Play.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>1.3.</strong> Kontakt z administratorem: e-mail: kontakt@losuje.pl
        </p>

        <h3 style={{ 
          fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '20px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '18px' : isMobile ? '20px' : '25px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          2. Charakter aplikacji
        </h3>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>2.1.</strong> Aplikacja umożliwia generowanie liczb do gier Lotto, korzystanie z mini-gier oraz generatora statystycznego opartego na analizie danych.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>2.2.</strong> Aplikacja ma charakter rozrywkowy i nie gwarantuje żadnej wygranej.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>2.3.</strong> Aplikacja nie jest związana z Totalizatorem Sportowym ani innymi organizatorami gier hazardowych.
        </p>

        <h3 style={{ 
          fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '20px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '18px' : isMobile ? '20px' : '25px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          3. Subskrypcja i płatności
        </h3>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.1.</strong> Wybrane funkcje aplikacji dostępne są w ramach płatnej subskrypcji.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.2.</strong> Subskrypcja jest odnawiana automatycznie (np. co miesiąc), aż do momentu jej anulowania przez użytkownika w ustawieniach Google Play.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.3.</strong> Cena subskrypcji: 9,99 PLN / miesiąc (pełny dostęp do aplikacji).
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.4.</strong> Cena subskrypcji: 59,90 PLN / rok (pełny dostęp do aplikacji).
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.5.</strong> Płatności są realizowane za pośrednictwem Google Play i podlegają ich regulaminowi.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>3.6.</strong> Użytkownik może zarządzać subskrypcją i anulować ją w dowolnym momencie poprzez konto Google.
        </p>

        <h3 style={{ 
          fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '20px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '18px' : isMobile ? '20px' : '25px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          4. Odpowiedzialność
        </h3>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>4.1.</strong> Aplikacja służy wyłącznie do celów rozrywkowych i nie gwarantuje wyników w żadnej loterii ani grze liczbowej.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>4.2.</strong> Właściciel nie ponosi odpowiedzialności za brak wygranych ani decyzje użytkownika podejmowane na podstawie wyników aplikacji.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>4.3.</strong> Właściciel nie gwarantuje stałej dostępności aplikacji i zastrzega sobie prawo do przerw technicznych.
        </p>

        <h3 style={{ 
          fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '20px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '10px' : isMobile ? '12px' : '15px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '18px' : isMobile ? '20px' : '25px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          5. Postanowienia końcowe
        </h3>
        <p style={{ 
          marginBottom: isSmallMobile ? '6px' : isMobile ? '8px' : '10px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>5.1.</strong> Regulamin obowiązuje od dnia publikacji w Google Play.
        </p>
        <p style={{ marginBottom: '10px' }}>
          <strong>5.2.</strong> Właściciel zastrzega prawo do zmian regulaminu.
        </p>
        <p style={{ marginBottom: '15px' }}>
          <strong>5.3.</strong> W sprawach nieuregulowanych stosuje się przepisy prawa polskiego.
        </p>

        <div style={{
          background: '#fff3cd',
          border: '2px solid #ffc107',
          borderRadius: '8px',
          padding: '20px',
          marginTop: '30px'
        }}>
          <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#856404' }}>
            ⚠️ WAŻNE OSTRZEŻENIE
          </h3>
          <p style={{ marginBottom: '10px', fontWeight: '600', color: '#856404' }}>
            Generator nie gwarantuje wygranej!
          </p>
          <p style={{ color: '#856404' }}>
            Aplikacja służy wyłącznie celom rozrywkowym. Lotto pozostaje grą losową, 
            a żaden generator nie może gwarantować wygranej ponad prawdopodobieństwo matematyczne.
          </p>
        </div>

        <p style={{ marginTop: '30px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
          <strong>Ostatnia aktualizacja:</strong> {new Date().toLocaleDateString('pl-PL')}
        </p>
      </div>
    </div>
  );
};

export default TermsOfServiceGooglePlay;
